import React, {ReactNode} from "react";
import ConfirmationDialog from "./ConfirmationDialog";
import {_transl} from "../../store/localization/TranslMessasge";
import {CommonTranslationKey} from "../../pages/main/content/CommonTranslationKey";
import DialogErrorAlert from "./DialogErrorAlert";

export interface DeleteConfirmationDialogProps {
    open: boolean;
    title: string;
    message: string;
    confirmButtonLabel?: string;
    dismissButtonLabel?: string;
    destructive?: boolean;
    deleteDisabled?: boolean;
    errorText?: string;
    onDelete: () => void;
    onDismiss: () => void;
    children?: ReactNode;
}

export default function DeleteConfirmationDialog(props: DeleteConfirmationDialogProps) {
    const {open, title, message, confirmButtonLabel = _transl(CommonTranslationKey.DELETE), dismissButtonLabel = _transl(CommonTranslationKey.KEEP), destructive = true, deleteDisabled, errorText, onDelete, onDismiss, children} = props;

    return (
        <ConfirmationDialog
            open={open}
            title={title}
            message={message}
            confirmButtonLabel={confirmButtonLabel}
            confirmDisabled={deleteDisabled}
            dismissButtonLabel={dismissButtonLabel}
            destructive={destructive}
            onConfirm={onDelete}
            onDismiss={onDismiss}
        >
            {children}
            <DialogErrorAlert errorText={errorText} />
        </ConfirmationDialog>
    );
}